import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CheckCircle as CheckIcon, Campaign as AdsIcon } from '@mui/icons-material';

// PUBLIC success page for the "we sent the client a link" flow. When a NOT-logged-in client
// finishes TikTok Ads authorization, the callback auto-creates one connector per advertiser
// account and redirects here (see tiktok-oauth.js). This page must NOT depend on auth/company
// context — the client is not logged into the platform.
const TikTokAdsSuccess = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh', p: 3 }}>
      <Paper elevation={3} sx={{ maxWidth: 520, width: '100%', p: 5, textAlign: 'center', borderRadius: 3 }}>
        <CheckIcon sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
          <AdsIcon sx={{ color: '#FE2C55' }} />
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            TikTok Ads connected
          </Typography>
        </Box>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your TikTok advertiser account(s) have been authorized and connected successfully.
          We'll begin syncing your ad campaign and performance data automatically — there's
          nothing more you need to do.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          You can safely close this window.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/connectors')}
          sx={{ backgroundColor: '#FE2C55', '&:hover': { backgroundColor: '#E0274D' } }}
        >
          Go to SuperChargeMe
        </Button>
      </Paper>
    </Box>
  );
};

export default TikTokAdsSuccess;
